import React from "react";
import { Grid } from "@mui/material";
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 16,
    borderRadius: 8,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 500 : 200],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.primary.main,
    },

}));

function ProgressBar({ data, theme }) {
    const total = isNaN(data.total) ? 0 : data.total;
    const percentage = total > 0 ? data.percentage : 0;

    return (
        <Grid item xs={12}>
            <dl className="list-progress">
                <dt>{data.title}</dt><dd>{total} {data.label}</dd>
            </dl>
            <BorderLinearProgress theme={theme} variant="determinate" value={percentage} />
        </Grid>
    );
}

export default ProgressBar;
